<div class="quiz-page">
  <div class="quiz-container">
    <div class="left-pane">
      <h3>
        <i class="bi bi-cloud-arrow-up me-2"></i>
        Upload Questions via CSV
      </h3>
      <p class="subtitle">
        Bulk-import questions by uploading a CSV that matches the required
        structure.
      </p>

      <button class="btn-outline" (click)="downloadTemplate()">
        <i class="bi bi-download me-2"></i>
        Download Template
      </button>

      <div class="upload-box" (click)="fileInput.click()">
        <input
          type="file"
          #fileInput
          hidden
          (change)="onFileSelected($event)"
        />

        <div class="upload-icon" *ngIf="!fileName">
          <i class="bi bi-upload"></i>
        </div>
        <p>Drop your CSV here, or <span class="link">browse</span></p>
        <small>Accepts .csv up to 5 MB</small>
      </div>

      <div *ngIf="fileName" class="file-card">
        <div class="file-left">
          <i class="bi bi-file-earmark-pdf file-icon"></i>

          <div class="file-info">
            <span class="file-name">{{ fileName }}</span>
            <span class="file-size" *ngIf="selectedFile">
              {{ (selectedFile.size / 1024).toFixed(1) }} KB
            </span>
          </div>
        </div>

        <button class="remove-btn" (click)="removeFile($event)">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="stats-wrapper mt-2" *ngIf="isFileUploaded">
        <div class="stats-container">
          <div
            class="stats-card"
            *ngFor="let item of stats"
            [ngClass]="item.type">
            <div class="left">
              <i class="icon" [ngClass]="[item.icon, item.type]"></i>
              <div class="number">{{ item.value }}</div>
            </div>

            <div class="right">
              <div class="label">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <div class="text">
          <i class="bi bi-check-fill me-2"></i>
          2 questions added to the Question Bank with Course, Difficulty and
          Topic tags applied.
        </div>
      </div>

      <div class="card" *ngIf="isFileUploaded">
        <h4>Required CSV Format</h4>

        <table>
          <thead>
            <tr>
              <th>Question</th>
              <th>Option1</th>
              <th>Option2</th>
              <th>Option3</th>
              <th>Option4</th>
              <th>Answer</th>
              <th>Difficulty</th>
              <th>Course</th>
              <th>Topic</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let csvQuestion of csvQuestions">
              <td>{{ csvQuestion.question }}</td>
              <td>{{ csvQuestion.option1 }}</td>
              <td>{{ csvQuestion.option2 }}</td>
              <td>{{ csvQuestion.option3 }}</td>
              <td>{{ csvQuestion.option4 }}</td>
              <td>{{ csvQuestion.answer }}</td>
              <td>{{ csvQuestion.difficulty }}</td>
              <td>{{ csvQuestion.course }}</td>
              <td>{{ csvQuestion.topic }}</td>
            </tr>
          </tbody>
        </table>

        <div class="rules">
          <p>✔<span>Question</span> — text, required</p>
          <p>✔ <span>Option1–4</span> — minimum 2 options</p>
          <p>✔ <span>Answer</span> — must match one option</p>
          <p>✔ <span>Difficulty</span> — Easy, Medium, Hard</p>
          <p>✔ <span>Course</span> — must exist</p>
          <p>✔ <Span>Topic</Span> — optional</p>
        </div>
      </div>

      <div class="validation" *ngIf="isFileUploaded">
        <h4>
          <i class="bi bi-patch-check"></i>
          Validation Rules
        </h4>
        <ul>
          <li>Rows missing required fields are rejected.</li>
          <li>Invalid difficulty values are rejected.</li>
          <li>Answer must match options.</li>
          <li>Unknown courses are rejected.</li>
          <li>Duplicate questions give warnings.</li>
        </ul>
      </div>
    </div>

    <div class="right-pane">
      <app-question-preview
        [isPreviewVisible]="showPreview"
      ></app-question-preview>
    </div>
  </div>
</div>